import React from 'react';
import { AlertMessage } from '../../../../../components/AlertMessage';

interface PropTypes {
  scheduledInterviewsCount: number;
  interviewTemplatesCount: number;
}

export function CurrentlyAssignedAlertMessage(props: PropTypes) {
  if (props.scheduledInterviewsCount == 0 && props.interviewTemplatesCount == 0)
    return;

  return (
    <AlertMessage
      hasOverlay={false}
      icon={{ name: 'bi-info-circle' }}
      className='mt-3 fs-5 bg-yellow-light w-100'
      text={
        <>
          <div>
            This user is currently assigned to:
            <ul className='ps-3'>
              {props.interviewTemplatesCount > 0 && (
                <li>{props.interviewTemplatesCount} scheduling template(s)</li>
              )}
              {props.scheduledInterviewsCount > 0 && (
                <li>{props.scheduledInterviewsCount} upcoming interview(s)</li>
              )}
            </ul>
          </div>
          <div className='mt-2'>
            Interviews will be automatically cancelled and rescheduled with the
            New Assignee as the host.
          </div>
        </>
      }
    />
  );
}
